import type { FunctionComponent } from 'react';
import React, { useCallback, useContext, useState } from 'react';

import { ResponsiveBoardHeaderContext } from 'app/src/components/BoardHeader/ResponsiveBoardHeaderContext';
import { SingleBoardViewProvider } from 'app/src/components/BoardViewContext/SingleBoardViewProvider';
import { SingleBoardViewFiltersProvider } from 'app/src/components/ViewFilters/SingleBoardViewFiltersProvider';
import type { FilterPopoverButtonProps } from './FilterPopoverButton';
import { FilterPopoverButton } from './FilterPopoverButton';

interface Props extends Omit<FilterPopoverButtonProps, 'PopoverWrapper'> {
  idBoard: string;
}

export const BoardFilterPopoverButton: FunctionComponent<Props> = ({
  idBoard,
  ...rest
}) => {
  const [skip, setSkip] = useState(true);
  const loadData = useCallback(() => skip && setSkip(false), [skip, setSkip]);

  const { isComponentCollapsed } = useContext(ResponsiveBoardHeaderContext);
  const isCollapsed = isComponentCollapsed('FilterPopoverButton');

  return (
    <SingleBoardViewFiltersProvider idBoard={idBoard}>
      <SingleBoardViewProvider idBoard={idBoard} skip={skip}>
        <FilterPopoverButton
          {...rest}
          onLoad={loadData}
          isCollapsed={isCollapsed}
        />
      </SingleBoardViewProvider>
    </SingleBoardViewFiltersProvider>
  );
};
